import React from 'react';
import { useLocation } from 'react-router-dom';
import { resolveRouteCapability } from '../../constants/routeCapabilityConfig';
import './RouteCapabilityBanner.css';

export const RouteCapabilityBanner: React.FC = () => {
  const { pathname } = useLocation();
  const spec = resolveRouteCapability(pathname);
  if (!spec) return null;

  return (
    <div
      className={`route-capability-banner route-capability-banner--${spec.status}`}
      role="status"
      data-route-capability={spec.status}
    >
      <strong>{spec.label}</strong>
      {spec.detail ? <span>{spec.detail}</span> : null}
    </div>
  );
};

export default RouteCapabilityBanner;
